import { Dialog, DialogTitle } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useUILanguage } from '.';
import LanguageList from '../../components/LanguageList';
import messages from './messages';

const UnknownLocaleModal = () => {
  const { locale, setLocale, shouldShowUnknownLocaleModal } = useUILanguage();
  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      aria-labelledby="language-dialog-title"
      open={shouldShowUnknownLocaleModal}
    >
      <DialogTitle id="language-dialog-title">
        <FormattedMessage {...messages.selectYourLanguage} />
      </DialogTitle>
      <LanguageList
        currentLocale={locale}
        onLocaleSelect={(appLocale) => {
          setLocale(appLocale);
        }}
      />
    </Dialog>
  );
};

export default UnknownLocaleModal;
